import type { Empresa } from '@/types/types';

export function filtrarEmpresasConCorrecciones(empresas: Empresa[]): Empresa[] {
  return empresas.filter((empresa) => (empresa.cantidadAsesoriasConCorreccionesPendientes ?? 0) > 0);
}
